import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a92357b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_sale_order",
  ref: "addDraftOrderModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_sale_order_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_sale_order_scroll",
  "data-kt-scroll": "false",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_sale_order_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_sale_order_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-7" }
const _hoisted_13 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-7" }
const _hoisted_16 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_17 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_18 = { class: "form-group mb-7" }
const _hoisted_19 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_20 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_21 = { class: "form-group mb-7" }
const _hoisted_22 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_23 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_24 = { class: "form-group mb-7" }
const _hoisted_25 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_26 = {
  key: 3,
  class: "col-md-6"
}
const _hoisted_27 = { class: "form-group mb-7" }
const _hoisted_28 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_29 = {
  key: 4,
  class: "col-md-6"
}
const _hoisted_30 = { class: "form-group mb-7" }
const _hoisted_31 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_32 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_33 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_34 = {
  key: 5,
  class: "col-md-6"
}
const _hoisted_35 = { class: "form-group mb-7" }
const _hoisted_36 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_37 = { class: "col-md-12" }
const _hoisted_38 = { class: "form-group mb-7" }
const _hoisted_39 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_40 = {
  key: 6,
  class: "col-md-12"
}
const _hoisted_41 = { class: "form-group mb-7" }
const _hoisted_42 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_43 = { class: "svg-icon svg-icon-5tx svg-icon-primary" }
const _hoisted_44 = { class: "el-upload__text" }
const _hoisted_45 = { class: "thumbnail-item" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "el-upload-list__item-actions" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_52 = { class: "el-upload__tip" }
const _hoisted_53 = { class: "modal-footer flex-center" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "indicator-label" }
const _hoisted_58 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_59 = { class: "indicator-progress" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("common.add")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("salesOrder.type")), 1),
                      _createVNode(_component_el_form_item, { prop: "config_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.config_id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.config_id) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            onChange: _ctx.storeChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.config_id, (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: item.value
                                }, [
                                  (
                              ((item.value === '2' || item.value === '14') &&
                                _ctx.type === 1) ||
                              (item.value !== '2' &&
                                item.value !== '14' &&
                                _ctx.type === 0)
                            )
                                    ? (_openBlock(), _createBlock(_component_el_option, {
                                        key: 0,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder", "onChange"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("salesOrder.customer")), 1),
                      _createVNode(_component_el_form_item, { prop: "customer_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            ref: "selectCustomer",
                            onFocus: _ctx.cancelReadonly,
                            "onHook:mounted": _ctx.cancelReadonly,
                            onVisibleChange: _ctx.cancelReadonly,
                            teleported: false,
                            modelValue: _ctx.formData.customer,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.customer) = $event)),
                            filterable: "",
                            clearable: "",
                            "remote-show-suffix": "",
                            remote: "",
                            placeholder: _ctx.t('common.plsEnter'),
                            "remote-method": _ctx.searchCustomerItems,
                            loading: _ctx.options.customerLoading,
                            onChange: _ctx.customerChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.customer, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "placeholder", "remote-method", "loading", "onChange"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (_ctx.type === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("salesOrder.distributionModel")), 1),
                          _createVNode(_component_el_form_item, { prop: "distribution_model" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.distribution_model,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.distribution_model) = $event)),
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.distribution_model, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.config_id == '13')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("salesOrder.paymentMethod")), 1),
                          _createVNode(_component_el_form_item, { prop: "payment_method" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.payment_method,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.payment_method) = $event)),
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.draft_order_payment_methods, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.config_id == '1' || _ctx.formData.config_id == '12')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t("salesOrder.deliveryDateAdjustment")), 1),
                          _createVNode(_component_el_form_item, { prop: "due_date" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.formData.due_date,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.due_date) = $event)),
                                type: "date",
                                clearable: "",
                                placeholder: _ctx.t('common.pickDate'),
                                style: {"width":"100%"},
                                onChange: _cache[5] || (_cache[5] = ($event: any) => (
                          _ctx.commonChangeDefaultDate($event, _ctx.formData, 'due_date')
                        )),
                                teleported: false
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.config_id == '1' || _ctx.formData.config_id == '12')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("salesOrderOverview.depositPaymentStatus")), 1),
                          _createVNode(_component_el_form_item, { prop: "deposit_payment_status" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.formData.deposit_payment_status,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.deposit_payment_status) = $event)),
                                filterable: "",
                                clearable: "",
                                remote: "",
                                placeholder: _ctx.t('common.plsSelect'),
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.deposit_payment_status, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.config_id == '1' || _ctx.formData.config_id == '12')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t("salesOrderOverview.depositPaidAmount")), 1),
                          _createVNode(_component_el_form_item, { prop: "deposit_amount" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_32, [
                                _createVNode(_component_el_input_number, {
                                  class: "text-start w-100",
                                  modelValue: _ctx.formData.deposit_amount,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.deposit_amount) = $event)),
                                  precision: 2,
                                  step: 0.01,
                                  min: 0,
                                  controls: false
                                }, null, 8, ["modelValue", "step"]),
                                _createElementVNode("div", _hoisted_33, [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.formData.deposit_currency,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.deposit_currency) = $event)),
                                    placeholder: _ctx.t('common.plsSelect'),
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.currency, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "placeholder"])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.config_id == '12')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("salesOrder.orderTagging")), 1),
                          _createVNode(_component_el_form_item, { prop: "tagging" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.tagging,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.tagging) = $event)),
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.tagging, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.t("salesOrder.remark")), 1),
                      _createVNode(_component_el_form_item, { prop: "comment" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.comment,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.comment) = $event)),
                            type: "textarea",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (_ctx.formData.config_id == '1' || _ctx.formData.config_id == '12')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.t("salesOrderOverview.plsPaymentVoucher")), 1),
                          _createVNode(_component_el_form_item, { prop: "file_id" }, {
                            default: _withCtx(() => [
                              _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                                ref: "uploadRef",
                                class: _normalizeClass(["multiple-drag-upload bg-light-primary rounded border-primary border border-dashed", { hasfile: _ctx.fileList.length > 0 }]),
                                drag: "",
                                multiple: "",
                                "file-list": _ctx.fileList,
                                "auto-upload": false,
                                "show-file-list": true,
                                accept: ".jpg,.jpeg,.png",
                                headers: _ctx.uploadHeaders,
                                "on-change": _ctx.onUploadChange,
                                "on-error": _ctx.onUploadError
                              }, {
                                file: _withCtx(({ file }) => [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("img", {
                                      class: "el-upload-list__item-thumbnail",
                                      src: file.url,
                                      alt: ""
                                    }, null, 8, _hoisted_46),
                                    _createElementVNode("span", _hoisted_47, [
                                      _createElementVNode("span", {
                                        class: "el-upload-list__item-preview",
                                        onClick: ($event: any) => (_ctx.handlePreview(file))
                                      }, [
                                        _createElementVNode("span", _hoisted_49, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen004.svg" })
                                        ])
                                      ], 8, _hoisted_48),
                                      _createElementVNode("span", {
                                        class: "el-upload-list__item-delete",
                                        onClick: ($event: any) => (_ctx.handleRemove(file))
                                      }, [
                                        _createElementVNode("span", _hoisted_51, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr015.svg" })
                                        ])
                                      ], 8, _hoisted_50)
                                    ])
                                  ])
                                ]),
                                tip: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.t("common.uploadAcceptSize", [
                                "jpg/jpeg/png",
                                "100M",
                              ])), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_43, [
                                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil022.svg" })
                                  ]),
                                  _createElementVNode("div", _hoisted_44, [
                                    _createTextVNode(_toDisplayString(_ctx.t("common.uploadDrop")) + " ", 1),
                                    _createElementVNode("em", null, _toDisplayString(_ctx.t("common.uploadClick")), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["class", "file-list", "headers", "on-change", "on-error"])), [
                                [_directive_loading, _ctx.uploadLoading]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", {
                type: "button",
                class: "btn btn-lg btn-light me-3",
                disabled: _ctx.uploadLoading,
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_55, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
              ], 8, _hoisted_54),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-primary",
                disabled: _ctx.loading || _ctx.uploadLoading,
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _createElementVNode("span", _hoisted_57, [
                  _createElementVNode("span", _hoisted_58, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_59, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_60
                ])
              ], 8, _hoisted_56)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}